/**
 * Which image, if any, a header shows.
 *
 * Shared by the editor preview and the live site so the two cannot drift —
 * a preview that disagrees with the published page is worse than no preview.
 *
 * `logoUrl` is the pre-`logo` field. Headers configured before the source
 * picker existed still have it, and silently dropping their logo on upgrade
 * would look like data loss.
 */
export default function resolveHeaderLogo(header, brandLogo) {
  if (!header) return null;

  const cfg = header.logo || {};
  const height = Math.min(80, Math.max(16, Number(cfg.height) || 30));

  if (cfg.source === 'none') return null;
  if (cfg.source === 'custom') {
    return cfg.customUrl ? { url: cfg.customUrl, height } : null;
  }
  if (cfg.source === 'brand') {
    // Falls back to the name when no brand logo is uploaded, rather than
    // leaving a gap where a mark should be.
    return brandLogo ? { url: brandLogo, height } : null;
  }

  // No source set: legacy header.
  return header.logoUrl ? { url: header.logoUrl, height } : null;
}
